//Searchanise only allows jQuery for thier API - https://docs.searchanise.io/js-api-events/
document.addEventListener('Searchanise.Loaded', () => {
  if (!window.Searchanise?.$ || !window.theme?.iso) return;
  const $ = window.Searchanise.$;

  const modifyProducts = (container) => {
    /*controlled within Searchanise's admin portal, the variant metafield "Restricted Countries" is rendered into each card literally.
     window.theme in theme.liquid has been augmented with the country name and iso code objects to match the logic/messaging found in product-card.liquid
    */

    container.find('.snize-attribute').each(function() {
      const $el = $(this);
      const codes = $el.text().split(',').map(c => c.trim());
  
      if (codes.includes(window.theme.iso)) {
        $el.html(`<div class="product-info_block" style="background-color: #fff5eb;border: 2pt solid #ffdeb3; margin: 10px 0"><p role="note" style="padding: 0.5em;text-align:left;margin:0;font-size:12px;"><strong>NOTICE:</strong> This product isn't available for shipping to <strong>${window.theme.country}</strong>.</p></div>`);
      }
    });
  };

  $(document).on('Searchanise.AutocompleteUpdated', (e, input, container) => {
    modifyProducts(container);
  });

  $(document).on('Searchanise.ResultsUpdated', (e, container) => {
    modifyProducts(container);
  });

  $(document).on('Searchanise.AddToCartSuccess', function(event, add_to_cart_id, product) {
    if (theme.settings.afterAtc === 'page') {
      window.location.href = theme.routes.cart;
      return;
    }

    setTimeout(async () => {
      const cartDrawer = document.querySelector('cart-drawer');
      if (cartDrawer) {
        await cartDrawer.refresh(true);
        if (theme.settings.afterAtc === 'drawer') {
          cartDrawer.open();
        }
      } else {
        const cartItems = document.querySelector('cart-items');
        if (cartItems) cartItems.refresh();
      }

      const variantId = product.variant_id || product.product_id || product.id;
      document.dispatchEvent(new CustomEvent('on:cart:add', {
        bubbles: true,
        detail: { variantId }
      }));
    }, 0);
  });
});
